import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faSearch, faShoppingBag, faQuestionCircle, faGlobeAsia, faSignOutAlt, faCheckCircle, faTimesCircle, faCommentDots, faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// for bootstrap
Vue.use(BootstrapVue)

//  for fontawesome
library.add(faUserSecret, faQuestionCircle, faSearch, faShoppingBag, faGlobeAsia, faSignOutAlt, faCheckCircle, faTimesCircle, faCommentDots, faBars)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
